<style scoped lang="scss">
    .bottom {
        justify-content: flex-end;
    }

</style>
<template>
    <div>
        <div class="pl15 pr15 pt10 pb10 flex bb aic">
            <ol class="btns flex aic pointer">
                <li v-for="(val,key) in btns" class="flex flex1 mr5 aic column" @click="operatHandler(key)">
                        <img :src="val" alt="" class="flex1" width="20px">
                        <span class="flex0 color_666 fs10 ml5">{{key}}</span>
                </li>
            </ol>
            <slot name="btns"></slot>
        </div>
    </div>
</template>

<script>
  export default {
    name: "video-tool-bar",
      props:{
        share:{
            type:Boolean,
            default:true
        }
      },
    data() {
      return {
        btns: {
          '图片': require('../../assets/icon/tupian.png'),
          '白板': require('../../assets/icon/baiban.png'),
          '桌面分享': require('../../assets/icon/zhuomianfenxiang.png'),
          '文件传输': require('../../assets/icon/wenjianchuanshuzhushou.png'),
            '邀请讨论': require('../../assets/icon/yaoqing.png'),
        }
      }
    },
    methods:{
      operatHandler(key){
        this.$emit('handler',key)
      }
    },
      created() {
          if(!this.share){
              delete this.btns['邀请讨论']
          }
      }
  }
</script>
